import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { cancelOrder } from "@repo/server-actions/account";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useCallback, useTransition } from "react";

const useCancelOrder = (
  formValues,
  setFormErrors,
  orderId,
  setFormValues,
  setCancelOrderDrawer
) => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const t = useTranslations("Common");
  const locale = useLocale();
  const { showSnackbar } = useSnackbarHandler();

  const submitForm = useCallback(async () => {
    const payLoad = {
      message:
        formValues.inputreason !== ""
          ? formValues.inputreason
          : formValues?.selectreason,
    };
    const response = await cancelOrder(payLoad, orderId, locale);
    showSnackbar(response);
    if (response?.data?.status === "CANCELLED") {
      setCancelOrderDrawer(false);
      router.refresh();
    }
  }, [formValues, orderId, router, setCancelOrderDrawer, locale, showSnackbar]);

  const handleCancelOrder = useCallback(
    (e, resend) => {
      e.preventDefault();

      const updatedFormValues = {
        ...formValues,
        ...(formValues?.selectreason !== "Other" && { inputreason: "" }),
      };
      setFormValues(updatedFormValues);
      const errors = validation(updatedFormValues, t);
      if (Object.keys(errors).length === 0) {
        startTransition(() => submitForm(resend));
      } else {
        setFormErrors(errors);
      }
    },
    [formValues, setFormErrors, submitForm, setFormValues, t]
  );

  return { isPending, handleCancelOrder };
};

export default useCancelOrder;
